import { ReactComponent as NoSavedRequestSvg } from 'assets/svg/magnet.svg';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'util/Constants';

interface Props {
    title?: string;
    description?: string;
    Icon?: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
}

export default function NoItems({
    title = 'No Saved Requests Yet',
    description = 'When you save a client request, it will appear here, ready for you to review and take action!',
    Icon = NoSavedRequestSvg,
}: Props) {
    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        navigate(`${ROUTES.SETTING}?tab=2`);
    };

    return (
        <div className="flex items-center flex-col font-poppins gap-4 justify-center min-h-screen">
            <Icon />
            <h5 className="text-lg text-my-black font-semibold">{title}</h5>
            <p className="text-my-black/80 text-base font-normal text-center max-w-[400px] leading-6">{description}</p>
            {title === 'Upgrade Your Plan' && (
                <Button
                    variant="contained"
                    onClick={handleUpgradeClick}
                    sx={{
                        backgroundColor: '#4EBBB8',
                        '&:hover': {
                            backgroundColor: '#3da8a5',
                        },
                    }}
                >
                    Upgrade Plan
                </Button>
            )}
        </div>
    );
}
